// ============================================================================
// ENTITY ACCOUNTING CONFIG SERVICE (functional currency + default ledgers)
// Entity-scoped via X-Entity-ID header.
// ============================================================================

import { get, put, del } from '../client/axiosClient';
import { entityAccountingConfigEndpoints } from '../endpoints/accounts.endpoints';
import type {
  ApiResponse,
  EmptyResponse,
  EntityAccountingConfigDto,
  UpdateEntityAccountingConfigRequest,
  LedgerDefaultDto,
  SetLedgerDefaultRequest,
  LedgerPurposeDto,
} from '../types';

class EntityAccountingConfigService {
  async getConfig(): Promise<EntityAccountingConfigDto> {
    const response = await get<ApiResponse<EntityAccountingConfigDto>>(entityAccountingConfigEndpoints.config());
    return response.data.data;
  }

  async saveConfig(data: UpdateEntityAccountingConfigRequest): Promise<EntityAccountingConfigDto> {
    const response = await put<ApiResponse<EntityAccountingConfigDto>>(entityAccountingConfigEndpoints.config(), data);
    return response.data.data;
  }

  async getLedgerDefaults(): Promise<LedgerDefaultDto[]> {
    const response = await get<ApiResponse<LedgerDefaultDto[]>>(entityAccountingConfigEndpoints.ledgerDefaults());
    return response.data.data ?? [];
  }

  async setLedgerDefault(data: SetLedgerDefaultRequest): Promise<LedgerDefaultDto> {
    const response = await put<ApiResponse<LedgerDefaultDto>>(entityAccountingConfigEndpoints.ledgerDefaults(), data);
    return response.data.data;
  }

  async clearLedgerDefault(purposeCode: string): Promise<EmptyResponse> {
    const response = await del<EmptyResponse>(entityAccountingConfigEndpoints.clearLedgerDefault(purposeCode));
    return response.data;
  }

  async getPurposes(): Promise<LedgerPurposeDto[]> {
    const response = await get<ApiResponse<LedgerPurposeDto[]>>(entityAccountingConfigEndpoints.purposes());
    return response.data.data ?? [];
  }
}

export const entityAccountingConfigService = new EntityAccountingConfigService();
export default entityAccountingConfigService;
